<div class="email-modal-overlay" (click)="onBackdropClick($event)">
  <section
    class="email-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="request-email-title"
    (click)="$event.stopPropagation()"
  >
    <header class="email-modal-header">
      <div>
        <p class="email-modal-eyebrow">Request upload</p>
        <h2 id="request-email-title">Compose email</h2>
      </div>
      <button
        type="button"
        class="email-modal-close"
        aria-label="Close email composer"
        [disabled]="sending"
        (click)="close()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="email-modal-body">
      <div class="email-routing-card">
        <div class="email-routing-row">
          <span>From</span>
          <strong>{{ senderEmail }}</strong>
        </div>
        <div class="email-routing-row">
          <span>To</span>
          <strong>{{ recipient }}</strong>
          <mat-icon title="The recipient is generated from the project number">lock</mat-icon>
        </div>
      </div>

      <label class="email-field">
        <span>Subject</span>
        <div class="subject-composer">
          <span class="subject-prefix">{{ subjectPrefix }}</span>
          <span class="subject-divider">-</span>
          <input
            type="text"
            name="subjectSuffix"
            [(ngModel)]="subjectSuffix"
            placeholder="Optional subject details"
            [disabled]="sending"
          >
        </div>
        <small>The project and request reference are locked.</small>
      </label>

      <div class="email-field">
        <label for="request-email-cc">CC</label>
        <div class="cc-entry">
          <input
            id="request-email-cc"
            type="email"
            name="ccInput"
            [(ngModel)]="ccInput"
            placeholder="name@example.com"
            [disabled]="sending"
            (keydown)="onCcKeydown($event)"
          >
          <button
            type="button"
            class="secondary-button"
            [disabled]="sending || !ccInput.trim()"
            (click)="addCcAddresses()"
          >
            Add
          </button>
        </div>
        <small>Separate multiple addresses with commas or add them individually.</small>

        <div class="cc-chips" *ngIf="ccAddresses.length > 0">
          <span class="cc-chip" *ngFor="let address of ccAddresses; let index = index">
            {{ address }}
            <button
              type="button"
              [attr.aria-label]="'Remove ' + address"
              [disabled]="sending"
              (click)="removeCcAddress(index)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </span>
        </div>
      </div>

      <label class="email-field">
        <span>Message <span class="required-marker">*</span></span>
        <textarea
          name="body"
          [(ngModel)]="body"
          rows="7"
          placeholder="Enter the email message"
          [disabled]="sending"
          required
        ></textarea>
      </label>

      <div class="email-field">
        <div class="attachment-heading">
          <label for="request-email-files">Attachments</label>
          <span>{{ files.length }}/{{ limits.maxFiles }} files · {{ formatBytes(combinedFileSize) }}/{{ formatBytes(limits.maxCombinedBytes) }}</span>
        </div>

        <label class="file-picker" for="request-email-files" [class.disabled]="sending">
          <mat-icon>upload_file</mat-icon>
          <span>Select files</span>
          <input
            id="request-email-files"
            type="file"
            multiple
            [disabled]="sending"
            (change)="onFilesSelected($event)"
          >
        </label>

        <div class="attachment-list" *ngIf="files.length > 0">
          <div class="attachment-item" *ngFor="let file of files; let index = index">
            <mat-icon>insert_drive_file</mat-icon>
            <div>
              <strong>{{ file.name }}</strong>
              <small>{{ formatBytes(file.size) }}</small>
            </div>
            <button
              type="button"
              [attr.aria-label]="'Remove ' + file.name"
              [disabled]="sending"
              (click)="removeFile(index)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="email-modal-error" *ngIf="error" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span>{{ error }}</span>
      </div>
    </div>

    <footer class="email-modal-footer">
      <button type="button" class="secondary-button" [disabled]="sending" (click)="close()">
        Cancel
      </button>
      <button
        type="button"
        class="send-button"
        [disabled]="sending || !body.trim()"
        (click)="send()"
      >
        <mat-icon>{{ sending ? 'hourglass_empty' : 'send' }}</mat-icon>
        <span>{{ sending ? 'Sending...' : 'Send email' }}</span>
      </button>
    </footer>
  </section>
</div>
